import type { UpdateNotice } from '@teachpartner/contracts';
import { formatDay } from './time';

/** What the school's contact was told about a newer release (LIVE L4). */
export function updateNoticeText(notice: UpdateNotice): string {
  switch (notice.status) {
    case 'sent':
      return notice.at ? `Update email sent ${formatDay(notice.at)}` : 'Update email sent';
    case 'failed':
      return 'Update email failed';
    case 'no_contact':
      return 'No contact email — update email not sent';
    default:
      return 'Update email pending';
  }
}

/** Compact note next to the Outdated badge; nothing when no notice is due. */
export function UpdateNoticeNote({ notice }: { notice: UpdateNotice | null }) {
  if (!notice) return null;
  const tone = notice.status === 'sent' || notice.status === 'pending' ? 'muted' : 'text-warn';
  return (
    <small className={`update-notice ${tone}`} title={`Release ${notice.version}`}>
      {updateNoticeText(notice)}
    </small>
  );
}
